import { AnyAction } from 'redux';
import { CheckoutActions } from '../checkout.actions';

export const maklermandatVorhandenReducer = function (
  sectionState: boolean = null,
  action: AnyAction,
): boolean {
  switch (action.type) {
    case CheckoutActions.MAKLERMANDAT_VORHANDEN_CHANGED: {
      return action.payload.maklermandatVorhanden;
    }
    default:
      return sectionState;
  }
};
